// extracted by css-extract-rspack-plugin
export default {"cls1":"EmailLoginPage-cls1_kqO","cls2":"EmailLoginPage-cls2_O3o EmailLoginPage-cls1_kqO"};